'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var AdvancedHepGridDeleteRowButtonController = function AdvancedHepGridDeleteRowButtonController($scope, advancedHepGridActionsService, advancedHepSystemConfigButtonsUtilsService, configService, $rootScope, $q) {
  var gridPanel = $scope.gridPanelScope;
  $scope.isGridEditable = gridPanel.jqxGridSettings.editable;
  $scope.isDeleteButtonShown = false;
  $scope.onRowSelection = function (selectedRows, selectedRowIndexes) {
    $scope.isDeleteButtonShown = !$scope.isDefaultLevel && $scope.isGridEditable && selectedRows.length > 0;
    $scope.selectedRowIndexes = selectedRowIndexes;
  };
  function removeRowsFromGrid(selectedRowIndexes) {
    var loadedData = gridPanel.jqxGridSettings.source.loadedData;
    _.remove(loadedData, function (value, index) {
      return _.includes(selectedRowIndexes, index);
    });
  }
  function getRowsToRemoveFromServer(loadedData, selectedRowIndexes) {
    return _.transform(selectedRowIndexes, function (result, item) {
      var row = loadedData[item];
      if (!row.isNewlyAdded) {
        result.push(row);
      }
      return result;
    });
  }
  function removeRowsFromServer(loadedData, selectedRowIndexes) {
    var rowsToBeRemovedFromServer = getRowsToRemoveFromServer(loadedData, selectedRowIndexes);
    if (advancedHepGridActionsService.isHepWithNoHierarchy($scope.selected.type)) {
      _.pullAt(loadedData, selectedRowIndexes);
      if ($scope.selected.type === 'FOFareBasisCodePattern' || $scope.selected.type === 'FOUpSellBuyDownConfig' || $scope.selected.type === 'FOTacticalUserOverrides') {
        var hepKeys = _.chain(loadedData).map(function (data) {
          return data.hepKey;
        }).uniq().value();
        var rowsToBeDeleted = _.filter(rowsToBeRemovedFromServer, function (item) {
          return !_.includes(hepKeys, item.hepKey);
        });
        if (!_.isEmpty(rowsToBeDeleted)) {
          advancedHepGridActionsService.remove(rowsToBeDeleted, $scope.selected.type, $scope.selected.hierarchy);
        }
      }
      var dataToBeSaved = _.map(loadedData, _.clone);
      advancedHepGridActionsService.save(dataToBeSaved, $scope.selected.type, $scope.selected.hierarchy);
      return $q.resolve();
    }
    if (!_.isEmpty(rowsToBeRemovedFromServer)) {
      return advancedHepGridActionsService.remove(rowsToBeRemovedFromServer, $scope.selected.type, $scope.selected.hierarchy);
    }
    return $q.resolve();
  }
  $scope.removeRows = function () {
    var loadedData = _.map(gridPanel.jqxGridSettings.source.loadedData, _.clone);
    confirm(loadedData, $scope.selectedRowIndexes).then(function () {
      if (_.size($scope.selectedRowIndexes) >= 100) {
        $rootScope.$broadcast('confirmation:show', 'delete-limit');
        return false;
      }
      if (!$scope.disableRemovingFromServer) {
        removeRowsFromServer(loadedData, $scope.selectedRowIndexes).then(function (response) {
          if (response !== null && _.has(response, '0.failedMap.notDeleted.exceptionMessage')) {
            toastr.error('Unable to delete rows: ' + response[0].failedMap.notDeleted.exceptionMessage);
          } else {
            removeRowsFromGrid($scope.selectedRowIndexes);
            advancedHepSystemConfigButtonsUtilsService.reloadGrid(gridPanel);
          }
        });
      } else {
        removeRowsFromGrid($scope.selectedRowIndexes);
        advancedHepSystemConfigButtonsUtilsService.reloadGrid(gridPanel);
      }
    });
  };
  function isAnyDefinitionUsed(rowsToRemove, normalizations, assignments) {
    return _.some(rowsToRemove, function (rowToRemove) {
      var fareBrandsToRemove = _.chain(rowToRemove.fareBrandDefinitionParams).map('fareBrandConfiguration').value();
      if (!_.isEmpty(normalizations) && !_.isEmpty(normalizations[rowToRemove.carrier])) {
        var usedInNomalization = _.intersection(normalizations[rowToRemove.carrier], fareBrandsToRemove);
        if (!_.isEmpty(usedInNomalization)) {
          return true;
        }
      }
      if (!_.isEmpty(assignments) && !_.isEmpty(assignments[rowToRemove.carrier])) {
        var usedInAssignments = _.intersection(assignments[rowToRemove.carrier], fareBrandsToRemove);
        if (!_.isEmpty(usedInAssignments)) {
          return true;
        }
      }
      return false;
    });
  }
  function deletingUsedFareBrandDefinitions(loadedData, selectedRowIndexes) {
    var rowsToRemove = getRowsToRemoveFromServer(loadedData, selectedRowIndexes);
    var normalizations = configService.getDAFareBrandNormalizations();
    var fareBrandAssignments = configService.getDAFareBrandAssignments();
    return $scope.selected.type === 'DA_FareBrandDefinition' && !_.isEmpty(rowsToRemove) && (!_.isEmpty(normalizations) || !_.isEmpty(fareBrandAssignments)) && isAnyDefinitionUsed(rowsToRemove, normalizations, fareBrandAssignments);
  }
  function confirm(loadedData, selectedRowIndexes) {
    var defer = $q.defer();
    if (deletingUsedFareBrandDefinitions(loadedData, selectedRowIndexes)) {
      $rootScope.$broadcast('confirmation:show', 'delete-item', null, $scope.selected.type);
      var unbindConfirmEvent = $scope.$on('confirmation:delete-item:result', function (e, res) {
        if (res) {
          defer.resolve();
        } else {
          defer.reject();
        }
        unbindConfirmEvent();
      });
    } else {
      defer.resolve();
    }
    return defer.promise;
  }
};
AdvancedHepGridDeleteRowButtonController.$inject = ['$scope', 'AdvancedHepGridActionsService', 'AdvancedHepSystemConfigButtonsUtilsService', 'ConfigurationService', '$rootScope', '$q'];
module.exports = AdvancedHepGridDeleteRowButtonController;